import React from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DescriptionIcon from "@mui/icons-material/Description";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DoNotDisturbAltIcon from "@mui/icons-material/DoNotDisturbAlt";
import TimerIcon from "@mui/icons-material/Timer";
import KeyIcon from "@mui/icons-material/Key";

const WelcomeDialog = ({ open, onClose, user }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: 2,

          p: 2,
          width: "100%",
          maxWidth: 900,
        },
      }}
    >
      <DialogTitle>
        <Typography
          variant="h4"
          component="h1"
          sx={{ fontWeight: "bold", mb: 5 }}
        >
          Välkommen till provpassvyn!
        </Typography>

        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 16,
            top: 16,
            color: "text.secondary",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          {/* Left side with text */}
          <Box sx={{ maxWidth: { xs: "100%", md: "50%" } }}>
            <Box sx={{ display: "flex", alignItems: "flex-start", mb: 3 }}>
              <DescriptionIcon sx={{ color: "#ff6b6b", mr: 2, mt: 0.5 }} />
              <Typography>
                Slutfört prov krävs för att se facit och resultat, precis som
                när du gör högskoleprovet på plats.
              </Typography>
            </Box>
            {user.accountType === "teacher" ? (
              <Box sx={{ display: "flex", alignItems: "flex-start", mb: 3 }}>
                <KeyIcon sx={{ color: "#ff9e7d", mr: 2, mt: 0.5 }} />
                <Typography>
                  Dela med elever via provkod (inget konto krävs) genom att
                  klicka på nyckeln.
                </Typography>
              </Box>
            ) : (
              <Box sx={{ display: "flex", alignItems: "flex-start", mb: 3 }}>
                <AccessTimeIcon sx={{ color: "#ff9e7d", mr: 2, mt: 0.5 }} />
                <Typography>
                  Provpasset lämnas in automatiskt när tiden är ute.
                </Typography>
              </Box>
            )}

            <Box sx={{ display: "flex", alignItems: "flex-start", mb: 3 }}>
              <VisibilityIcon sx={{ color: "#ff9e7d", mr: 2, mt: 0.5 }} />
              <Typography>
                Klicka på 'Översikt' för att se sparade frågor.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "flex-start", mb: 3 }}>
              <DoNotDisturbAltIcon sx={{ color: "#ff6b6b", mr: 2, mt: 0.5 }} />
              <Typography>
                Om du väljer att avbryta provpasset sparas dina svar, och du kan
                när som helst återuppta provet.
              </Typography>
            </Box>

            <Box sx={{ display: "flex", alignItems: "flex-start", mb: 3 }}>
              <TimerIcon sx={{ color: "#ff6b6b", mr: 2, mt: 0.5 }} />
              <Typography>
                Du kan dölja tiden och gå in i fokusläge genom att trycka på
                timern.
              </Typography>
            </Box>
          </Box>

          {/* Right side with image */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              justifyContent: "center",
              width: "50%",
            }}
          >
            <img
              src="/img/hp-splash.png"
              alt="Illustration av studiematerial"
              style={{ maxWidth: "80%", height: "auto" }}
            />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeDialog;
